import React from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import SettingsLayout from 'modules/settings/SettingsLayout/SettingsLayout';
import useEncryptedURLState from 'hooks/useEncryptedURLState';
import DeliverySettingsSection from './DeliverySettingsSection';
import useAutomationSettings from './useAutomationSettings';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';

function AutomationSettings() {
  const [activeIndex, setActiveIndex] = useEncryptedURLState('tab', 0, { encrypt: false });
  const { data, saving, saveSecureMessage, saveTextMessage, resetSecureMessage, resetTextMessage } = useAutomationSettings();
  return (
    <div>
      <GlobalLoader />
      <div className="row mt-2">
        <div className="col-12 billing-wrap pb-3">
          <TabView className="curve-tab" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} scrollable={true}>
            <TabPanel header="Text Messages">
              <DeliverySettingsSection
                title="Text Message Delivery Settings"
                onSave={saveTextMessage}
                onReset={resetTextMessage}
                initialValues={data?.text_message}
                saving={saving}
              />
            </TabPanel>
            <TabPanel header="Secure Messages">
              <DeliverySettingsSection
                title="Secure Message Delivery Settings"
                onSave={saveSecureMessage}
                onReset={resetSecureMessage}
                initialValues={data?.secure_message}
                saving={saving}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  );
}

const AutomationSettingsWrapped = (props) => {
  return (
    <SettingsLayout>
      <AutomationSettings {...props} />
    </SettingsLayout>
  );
};

export default AutomationSettingsWrapped;
